// jwt.interceptor.ts
import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';
import { NetworkErrorService } from '../services/network-error.service';
import { inject } from '@angular/core';

import { CurrencyService } from '../services/currency.service';
import { environment } from '../../../environments/environment';

export const jwtInterceptor: HttpInterceptorFn = (request, next) => {
  const currencyService = inject(CurrencyService);
  const networkService = inject(NetworkErrorService);
  // Inline language mapping to avoid injecting TranslationService (circular dependency)
  const LANG_MAP: Record<string, string> = {
    en: 'ENG',
    it: 'ITA',
    es: 'SPN',
    ar: 'ARB',
    fr: 'FRA',
    de: 'GER',
  };
  const uiLang = localStorage.getItem('uiLang') || 'en';
  const backendLang = LANG_MAP[uiLang] || 'ENG';
  const accessToken = localStorage.getItem('dreamAzureAccessToken') || '';

  // Calls that must not carry Channel-Source, built from the current build's
  // environment so the list matches on every environment, not only on dev.
  const skipUrls = [
    environment.utilUrl,
    // `${environment.baseUrlUser}users/data`,
  ];

  const isSkipUrl = skipUrls.some((url) => request.url.startsWith(url));

  let headers: any = {
    // Authorization: `Bearer ${accessToken}`,
    Authorization: `${accessToken}`,

    'X-Api-Key': `DREAMFLY0001FLIGHTFUSION0001`,
  };

  if (!isSkipUrl) {
    headers['Channel-Source'] = 'DREAM_AND_FLY';
  }
  const url = new URL(request.url, window.location.origin);
  url.searchParams.set('lang', backendLang);
  url.searchParams.set('currency', currencyService.currentCurrency());

  const cloned = request.clone({
    url: url.toString(),
    setHeaders: headers,
  });
  // const cloned = request.clone({
  //   setHeaders: headers,
  // });

  return next(cloned).pipe(
    catchError((error: HttpErrorResponse) => {
      // status 0 is also returned for CORS / gateway failures while online;
      // show the "No internet" screen only when the browser is really offline
      if (error.status === 0) {
        if (error.status === 0 && !navigator.onLine) {
          networkService.showError();
        }
      }
      return throwError(() => error);
    })
  );
};
